import jQuery from 'jquery';
(function init (){
    window.$ = jQuery;
})();

import '@popperjs/core';
import 'bootstrap';

import './ajax';
import './main';
